import React from 'react';
import Grid from '../Grid';
import Card from '../Card';
import {
  MessageSquareDot,
  CalendarX2,
  CircleDashed,
  CalendarCheck2,
} from 'lucide-react';
import Spacing from '../Spacing';
import { Link } from 'react-router-dom';

export default function OverViewSection3() {
  return (
    <Grid variant="docpro_grid_gap_4 docpro_grid_col_4">
      <Link to="/pending-appointments" className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
            <CircleDashed width={24} height={24} /> Pending appointments
          </h3>
          <Spacing lg="4" sm="4" />
          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
            14
          </p>
        </Card>
      </Link>
      <Link to="/confirmed-appointments" className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
            <CalendarCheck2 width={24} height={24} /> Confirmed appointments
          </h3>
          <Spacing lg="4" sm="4" />
          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
            13
          </p>
        </Card>
      </Link>
      <Link to="/expired-appointments" className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
            <CalendarX2 width={24} height={24} /> Expired appointments
          </h3>
          <Spacing lg="4" sm="4" />
          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
            9
          </p>
        </Card>
      </Link>
      <Link to="/unread-messages" className="docpro_card_1_link">
        <Card variant="docpro_card_md docpro_card_1">
          <h3 className="docpro_fs_14 docpro_mb_0 docpro_olive_color">
            <MessageSquareDot width={24} height={24} /> Unread messages
          </h3>
          <Spacing lg="4" sm="4" />
          <p className="docpro_fw_500 docpro_fs_28 docpro_primary_color docpro_mb_0">
            5
          </p>
        </Card>
      </Link>
    </Grid>
  );
}
